export const COPY_TASK = '__DS_COPY_TASK__';
export const COPY_TASK_RUNNER = '__DS_COPY_TASK_RUNNER__';
export const IS_COPYABLE = '__DS_IS_COPYABLE__';